<ng-container
    #user="user"
    lsUser
>
    <ng-container *lsUiNgLet="user.userInfo$ | async as userInfo">
        @if (isGamePage()) {
            <button
                class="bottom-menu-toggle _graphic-sub _graphic-sub-xs _500"
                type="button"
                (click)="toggleBottomMenu()"
            >
                {{ game()?.name }}
                <span class="bottom-menu-toggle__provider _400">{{ game()?.brand?.name }}</span>
                <ls-ui-icon
                    class="bottom-menu-toggle__icon"
                    height="24"
                    src="chevron"
                    width="24"
                />
            </button>
        }

        <div
            class="bottom-menu"
            [class._is-game-page]="isGamePage()"
        >
            <button
                class="bottom-menu__item _menu"
                [class._active]="isMenuOpen()"
                [attr.aria-label]="'common.button-menu' | translate"
                [name]="'common.button-menu' | translate"
                [title]="'common.button-menu' | translate"
                type="button"
                (click)="toggleMenu()"
            >
                <ng-container
                    *ngTemplateOutlet="iconTemplate; context: {
                        name: 'common.button-menu',
                        icon: 'menu',
                    }"
                />
            </button>

            <button
                class="bottom-menu__item _search"
                [attr.aria-label]="'common.button-search' | translate"
                [name]="'common.button-search' | translate"
                [title]="'common.button-search' | translate"
                type="button"
                (click)="openSearchPopup()"
            >
                <ng-container
                    *ngTemplateOutlet="iconTemplate; context: {
                        name: 'common.button-search',
                        icon: 'search',
                    }"
                />
            </button>

            @if (!isGamePage()) {
                <button
                    class="bottom-menu__item _games"
                    type="button"
                    [attr.aria-label]="'common.category-casino' | translate"
                    [name]="'common.category-casino' | translate"
                    [title]="'common.category-casino' | translate"
                    [routerLink]="['/game-categories/popular' | localize]"
                    routerLinkActive="_active"
                    (click)="closeMenu()"
                >
                    <ng-container
                        *ngTemplateOutlet="iconTemplate; context: {
                            name: 'common.category-casino',
                            icon: 'cards',
                        }"
                    />
                </button>

                <button
                    class="bottom-menu__item _promo"
                    type="button"
                    [attr.aria-label]="'common.promo' | translate"
                    [name]="'common.promo' | translate"
                    [title]="'common.promo' | translate"
                    [routerLink]="['/promotions' | localize]"
                    routerLinkActive="_active"
                    (click)="closeMenu()"
                >
                    <ng-container
                        *ngTemplateOutlet="iconTemplate; context: {
                            name: 'common.promo',
                            icon: 'gift',
                        }"
                    />
                </button>

                @if (userInfo !== null) {
                    <button
                        class="bottom-menu__item _profile"
                        type="button"
                        [attr.aria-label]="'common.button-profile' | translate"
                        [name]="'common.button-profile' | translate"
                        [title]="'common.button-profile' | translate"
                        [routerLink]="['/profile' | localize]"
                        routerLinkActive="_active"
                        (click)="closeMenu()"
                    >
                        <ls-bonus-amount [isProfilePage]="isProfilePage()">
                            <ng-container
                                *ngTemplateOutlet="iconTemplate; context: {
                                    name: 'common.button-profile',
                                    icon: 'user',
                                }"
                            />
                        </ls-bonus-amount>

                    </button>
                }
            }

            @if (isGamePage()) {
                <button
                    #fullScreen="fullScreen"
                    class="bottom-menu__item _fullscreen"
                    [attr.aria-label]="'common.full-screen' | translate"
                    [title]="'game.full-screen' | translate"
                    [name]="'game.full-screen' | translate"
                    lsFullScreen
                    (click)="fullScreen.changeFullScreen('#game-iframe')"
                >
                    <ls-ui-icon
                        height="24"
                        src="fullscreen"
                        width="24"
                    ></ls-ui-icon>
                </button>

                @if (isUser() && game()) {
                    <button
                        #changeFavorite="changeFavorite"
                        class="bottom-menu__item _favorite"
                        type="button"
                        [class._active]="changeFavorite.isFavorite()"
                        [attr.aria-label]="'common.button-favourite' | translate"
                        [name]="'common.button-favourite' | translate"
                        [lsChangeFavorite]="game()"
                        [title]="'common.button-favourite' | translate"
                    >
                        <ng-container
                            *ngTemplateOutlet="iconTemplate; context: {
                            name: changeFavorite.isFavorite() ? 'common.unlike' : 'common.like',
                            icon: 'heart',
                        }"
                        />
                    </button>
                }

                <button
                    lsLivechatButton
                    class="bottom-menu__item _support"
                    type="button"
                    [attr.aria-label]="'common.jivo' | translate"
                    [name]="'common.jivo' | translate"
                    [title]="'common.jivo' | translate"
                >
                    <ng-container
                        *ngTemplateOutlet="iconTemplate; context: {
                            name: 'common.jivo',
                            icon: 'support',
                        }"
                    />
                </button>

                @if (hasTournaments) {
                    <button
                        class="bottom-menu__item _tournaments"
                        type="button"
                        [class._active]="isTournamentsSidebarOpen()"
                        [attr.aria-label]="'common.category-tournaments' | translate"
                        [title]="'common.category-tournaments' | translate"
                        [name]="'common.category-tournaments' | translate"
                        (click)="toggleTournamentsSidebar()"
                    >
                        <ng-container
                            *ngTemplateOutlet="iconTemplate; context: {
                            name: 'common.category-tournaments',
                            icon: 'tournaments',
                        }"
                        />
                    </button>
                }
            }
        </div>
    </ng-container>
</ng-container>

<ng-template
    #iconTemplate
    let-icon="icon"
    let-name="name"
>
    <ls-ui-icon
        class="bottom-menu__icon"
        [src]="icon"
        height="24"
        width="24"
    />
    <span class="bottom-menu__text _graphic-p-xs _500">{{ name | translate }}</span>
</ng-template>
